import type { SVGProps } from 'react';

const PaymentCash = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="34"
    height="24"
    fill="none"
    data-name="Cash"
    viewBox="0 0 34 24"
    {...props}
  >
    <rect width={33} height={23} x={0.5} y={0.5} fill="#fff" stroke="#D9D9D9" rx={3.5} />
    <path
      fill="#000"
      d="M16.071 16.12h1.812v-.906h1.812v-4.529h-3.624v-.906h3.624V7.967h-1.812v-.906h-1.812v.906h-1.812v4.529h3.624v.906h-3.624v1.812h1.812v.906ZM26.036 4.344H7.927l-.009 14.494H26.036V4.344Zm-1.812 12.682H9.73V6.156h14.494v10.87Z"
    />
  </svg>
);
export default PaymentCash;
